import { headerShipToAddressStyles as styles } from "@tggstore/Overrides/Widgets/Common/HeaderShipToAddress";
import { css } from "styled-components";

styles.titleTypography = {
    ...styles.titleTypography,
    size: 18,

    css: css`
        margin: 0 5px;
        font-size: 18px;

        span {
            font-size: 18px;
        }

        span.header_shipToLabel_name {
            text-decoration-line: underline;
        }
    `,
    ellipsis: true,
    transform: "none",
};

styles.titleClickable = {
    ...styles.titleClickable,
    css: css`
        margin-left: 0;
    `,
};
